import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { FormataTelefone } from '@/shared/utils/telefones';
import { InstituicaoEnsinoService } from '@/modules/structure/instituicoes/instituicao.service';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';
import { validaCNPJ } from '@/shared/utils/cnpj';
import { ReadInstituicaoEnsinoDto } from '@/api.types';

export default function InstituicoesIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<ReadInstituicaoEnsinoDto[]>();
  const tableState = useDataTableState('razao_social');
  const instituicaoService = new InstituicaoEnsinoService();

  const handleBuscar = () => {
    instituicaoService
      .Enumerate()
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Instituicoes_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);


  let colunas: Column<ReadInstituicaoEnsinoDto>[] = [
    { key: "ordem", header: "Ordem" },
    {
      key: "cnpj", header: "CNPJ",
      render: (row) => { return (<b>{validaCNPJ(row.cnpj, true)}</b>) }
    },
    { key: "razao_social", header: "Razão Social" },
    { key: "representante_nome", header: "Representante" },
    {
      key: "telefone", header: "Telefone",
      render: (row) => { return (<>{FormataTelefone(''.concat(String(row.telefone?.ddd), String(row.telefone?.numero)))}</>) }
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Instituicoes_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Instituições de Ensino</h3>
          <span className="blockquote-footer pb-4 text-end">
            Universidades e faculdades.
          </span>
        </div>
        <hr className="pb-4" />

        {registros &&
          <DataTable
            columns={colunas}
            data={registros}
            initialSortKey='nome'
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros.length}
          />
        }
      </div>
    </>
  );
}
